import { doGet, doPost } from "../../api/baseAPI"
import { GROLOG_BASE_URL, GROLOG_ORDER_URL, GROLOG_URL } from "../../constant/apiConstant"

export const approve = async (token, refresh_token, data, params, dispatch) => {
  const result = { status: false, message: undefined }
  const url = `${GROLOG_ORDER_URL}/trip-planning/approve-trip`

  try {
    const res = await doPost(url, token, data, params)
    if (res) {
      result.status = true
      result.message = res.data.payload.status.message
    } else {
      result.status = false
      result.message = res.data.payload.status.message
    }
  } catch (error) {
    result.message = error.response.data.payload.message
    // checkValidationToken(error, token, refresh_token, dispatch)
  }

  return result
}

export const reject = async (token, refresh_token, data, params, dispatch) => {
  const result = { status: false, message: undefined }
  const url = `${GROLOG_ORDER_URL}/trip-planning/reject-trip`

  try {
    const res = await doPost(url, token, data, params)
    if (res) {
      result.status = true
      result.message = res.data.payload.status.message
    } else {
      result.status = false
      result.message = res.data.payload.status.message
    }
  } catch (error) {
    result.message = error.response.data.payload.message
    // checkValidationToken(error, token, refresh_token, dispatch)
  }

  return result
}

export const getManagementHistoryList = async (token, refresh_token, id) => {
  const url = `${GROLOG_BASE_URL}/audit/v1/grolog/audit?page=1&filter=table_name eq trip_planning, primary_key eq ${id}`;
  let result = { data: undefined, ok: false }

  try {
    const response = await doGet(token, url, null);
    if (response) {
      result.ok = true;
      result.data = response?.data?.payload
    }
  } catch (error) {
    result.message = error.response.data.payload.message

  }
  return result
}

export const detailTripPlanning = async (token, id) => {
  const url = `${GROLOG_ORDER_URL}/trip-planning/${id}`;
  const result = { ok: false, data: undefined, message: undefined }

  try {
    const res = await doGet(token, url);

    if (res?.status === 200) {
      result.ok = true;
      result.data = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
    }
  } catch (error) {
    const errorCode = error?.response?.status;
    const errorMessage = error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.data;
  }
  return result
}

export const listDA = async (token, params) => {
  const url = `${GROLOG_ORDER_URL}/trip-plannings/delivery-associate`;
  const initiateUrl = `${GROLOG_ORDER_URL}/trip-plannings/delivery-associate/initiate`;

  const result = { ok: false, list: undefined, initiate: undefined, message: undefined, code: null }

  try {
    const res = await doGet(token, url, params);
    const resInitiate = await doGet(token, initiateUrl, params);

    if ((res?.status && resInitiate?.status) === 200) {
      result.code = 200;
      result.ok = true;
      result.list = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
      result.initiate = resInitiate?.data?.payload?.data;
    }
  } catch (error) {
    const errorCode = error?.response?.status;
    const errorMessage = error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.list;
    delete result.initiate;
  }
  return result;
}

export const detailInTripPlanning = async (token, id) => {
  const url = `${GROLOG_ORDER_URL}/trip-plannings/delivery-associate/${id}`;
  const result = { ok: false, data: undefined, message: undefined }

  try {
    const res = await doGet(token, url);

    if (res?.status === 200) {
      result.ok = true;
      result.data = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
    }
  } catch (error) {
    const errorCode = error?.response?.status;
    const errorMessage = error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.data;
  }
  return result
}

export const listOrderNotAssign = async (token, params) => {
  const url = `${GROLOG_ORDER_URL}/trip-plannings/order-not-assign`;
  const initiateUrl = `${GROLOG_ORDER_URL}/trip-plannings/order-not-assign/initiate`;

  const result = { ok: false, list: undefined, initiate: undefined, message: undefined, code: null }

  try {
    const res = await doGet(token, url, params);
    const resInitiate = await doGet(token, initiateUrl, params);

    if ((res?.status && resInitiate?.status) === 200) {
      result.code = 200;
      result.ok = true;
      result.list = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
      result.initiate = resInitiate?.data?.payload?.data;
    }
  } catch (error) {
    const errorCode = error?.response?.status;
    const errorMessage = error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.list;
    delete result.initiate;
  }
  return result;
}

export const detailOrderNotAssign = async (token, id) => {
  const url = `${GROLOG_ORDER_URL}/trip-plannings/order-detail/${id}`;
  const result = { ok: false, data: undefined, message: undefined }

  try {
    const res = await doGet(token, url);

    if (res?.status === 200) {
      result.ok = true;
      result.data = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
    }
  } catch (error) {
    const errorCode = error?.response?.status;
    const errorMessage = error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.data;
  }
  return result
}

export const detailDepot = async (token, id) => {
  const url = `${GROLOG_URL}/depot-configuration/${id}`;
  const result = { ok: false, data: undefined, message: undefined }

  try {
    const res = await doGet(token, url);

    if (res?.status === 200) {
      result.ok = true;
      result.data = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
    }
  } catch (error) {
    const errorCode = error?.response?.status;
    const errorMessage = error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.data;
  }
  return result
}

export const listOrderTrip = async (token, params) => {
  const url = `${GROLOG_ORDER_URL}/trip-plannings/order-assign`;
  const initiateUrl = `${GROLOG_ORDER_URL}/trip-plannings/order-assign/initiate`;

  const result = { ok: false, list: undefined, initiate: undefined, message: undefined, code: null }

  try {
    const res = await doGet(token, url, params);
    const resInitiate = await doGet(token, initiateUrl, params);

    if ((res?.status && resInitiate?.status) === 200) {
      result.code = 200;
      result.ok = true;
      result.list = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
      result.initiate = resInitiate?.data?.payload?.data;
    }
  } catch (error) {
    const errorCode = error?.response?.status;
    const errorMessage = error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.list;
    delete result.initiate;
  }
  return result;
}

export const detailOrderList = async (token, id) => {
  const url = `${GROLOG_ORDER_URL}/trip-plannings/order-detail/${id}`;
  const result = { ok: false, data: undefined, message: undefined }

  try {
    const res = await doGet(token, url);

    if (res?.status === 200) {
      result.ok = true;
      result.data = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
    }
  } catch (error) {
    const errorCode = error?.response?.status;
    const errorMessage = error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.data;
  }
  return result
}

export const searchListOrderTrip = async (token, params) => {
  const url = `${GROLOG_ORDER_URL}/trip-plannings/order-assign/search`;

  const result = { ok: false, list: undefined, message: undefined, code: null }

  try {
    const res = await doGet(token, url, params);

    if (res?.status === 200) {
      result.code = 200;
      result.ok = true;
      result.list = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
    }
  } catch (error) {
    const errorCode = error?.response?.status;
    const errorMessage = error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.list;
  }
  return result;
}

export const getListDriverAssociate = async (token, payload, params) => {
    const result = { status: false, message: undefined, list: undefined };
    const url = `${GROLOG_URL}/delivery-associate/dropdown-list`;
  
    try {
      const res = await doPost(url, token, payload, params)
      if (res) {
        result.status = true;
        result.message = res.data.payload.status.message;
        result.list = res?.data?.payload?.data;
      } else {
        result.status = false
        result.message = res.data.payload.status.message
      }
    } catch (error) {
      result.message = error.response.data.payload.message;
      delete result.list;
      // checkValidationToken(error, token, refresh_token, dispatch)
    }
  
    return result
}

export const insertData = async (token, data, params) => {
  const url = `${GROLOG_ORDER_URL}/trip-planning`;
  let result = { ok: false, message: undefined }

  // dispatch(setTableLoading(true))
  try {
    const response = await doPost(url, token, data, params);
    if (response) {
      result.ok = true;
      result.data = response?.data?.payload?.status?.message
    }
  } catch (error) {
    result.message = error.response.data.payload.message;
  }
  return result
}

export const viewDetailListOrder = async (token, id) => {
  const url = `${GROLOG_ORDER_URL}/order/${id}`;
  const result = { ok: false, data: undefined, message: undefined }

  try {
    const res = await doGet(token, url);

    if (res?.status === 200) {
      result.ok = true;
      result.data = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
    }
  } catch (error) {
    const errorCode = error?.response?.status;
    const errorMessage = error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.data;
  }
  return result
}